import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import { connect } from 'react-redux';
import moment from 'moment';

import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';

import { timesheetActions } from '../../../_actions';
import ReadOnlyFormComponentTW from '../../Timesheet/ReadOnlyFormComponentTW';

class DataTableContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            readOnlyTimesheetTableOpen: false,
        };
    }

    componentDidMount() {
        if (this.props.user.isAdmin) {
            this.props.dispatch(timesheetActions.getAll());
        } else {
            this.props.dispatch(timesheetActions.getAllByDepartmentId(this.props.user.departmentId, this.props.user.id));
        }
    }

    handleReadOnlyTimesheetClose = () => {
        this.setState({
            readOnlyTimesheetTableOpen: false,
            timesheetId: ''
        })
    }

    handleReadOnlyTable = (value) => {
        this.setState({
            timesheetId: value,
            readOnlyTimesheetTableOpen: true
        })
    }

    render() {
        const { timesheet } = this.props;

        const columns = [
            {
                name: "Action",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <IconButton color="secondary" aria-label="Edit" onClick={event => this.handleReadOnlyTable(value)}>
                                <SearchIcon />
                            </IconButton>
                        );
                    },
                }
            },
            "部門",
            "姓名",
            {
                name: "日期",
                options: {
                    filter: true,
                    sort: true,
                    sortDirection: 'desc',
                    filterType: 'multiselect',
                }
            },
            "正常工時",
            "加班工時",
            {
                name: "成本單位",
                options: {
                    filterType: 'textField',
                }
            },
            "服務類別",
            {
                name: "工作內容",
                options: {
                    filter: false,
                },
            },
            {
                name: "工作滿意度",
                options: {
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            convertSatisfaction(value)
                        );
                    },
                }
            },
        ];

        let data = timesheet.items && timesheet.items.map(item => {
            return [
                item.TimesheetId,
                item.DepartmentId,
                item.UserName,
                moment(item.Date).format('YYYY-MM-DD'),
                item.Hours,
                item.HoursOvertime,
                item.CostUnitName ? item.CostUnitDefineId + ' - ' + item.CostUnitName : item.ProjectName,
                item.SubCategoryName,
                item.Notes,
                item.Satisfaction
            ]
        })

        const options = {
            filter: true,
            selectableRows: false,
            filterType: "dropdown",
            responsive: "stacked",
            rowsPerPage: 10,
        };

        return (
            <div>
                <MUIDataTable
                    title={"Timesheet"}
                    data={data}
                    columns={columns}
                    options={options}
                />
                <ReadOnlyFormComponentTW
                    open={this.state.readOnlyTimesheetTableOpen}
                    close={this.handleReadOnlyTimesheetClose}
                    TimesheetId={this.state.timesheetId}
                />
            </div>
        );
    }
}

function convertSatisfaction(Satisfaction) {
    switch (Satisfaction) {
        case 0:
            return <span role="img" aria-label="100">😂😂😂</span>
        case 1:
            return <span role="img" aria-label="80">😄😄</span>
        case 2:
            return <span role="img" aria-label="60">😊</span>
        case 3:
            return <span role="img" aria-label="50">🤔</span>
        case 4:
            return <span role="img" aria-label="40">😠</span>
        case 5:
            return <span role="img" aria-label="20">😤😤</span>
        case 6:
            return <span role="img" aria-label="0">😡😡😡</span>
        default:
            return null
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { timesheet } = state;

    return {
        user,
        timesheet
    };
}

export default connect(mapStateToProps)(DataTableContainer);


// WEBPACK FOOTER //
// ./src/components/AdminDashboard/Timesheet/DataTableContainer.js